/**
 * Performance utility functions
 */

/**
 * Throttles a function to only execute once per specified delay
 * @param {Function} func - Function to throttle
 * @param {number} delay - Delay in milliseconds
 * @returns {Function} Throttled function
 */
export function throttle(func, delay) {
    let lastCall = 0;
    let timeoutId = null;

    return function throttled(...args) {
        const now = Date.now();
        const timeSinceLastCall = now - lastCall;

        const execute = () => {
            lastCall = now;
            func.apply(this, args);
        };

        if (timeSinceLastCall >= delay) {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }
            execute();
        } else if (!timeoutId) {
            timeoutId = setTimeout(() => {
                timeoutId = null;
                execute();
            }, delay - timeSinceLastCall);
        }
    };
}
